import * as React from "react";

import { TableHeaderCell, TableRow } from "simplydo/react/ui/table";

const cellStyle = { border: "none" };

interface HeaderRangeProps {
  /** Selected dates range. */
  children: string;
}

function HeaderRange(props: HeaderRangeProps) {
  const { children } = props;

  return (
    <TableRow>
      <TableHeaderCell style={cellStyle} colSpan={7}>
        {children}
      </TableHeaderCell>
    </TableRow>
  );
}

export default HeaderRange;
